<template>
  <v-app style="-webkit-overflow-scrolling: touch">

    <v-snackbar v-model="snackbar" top="true" left="true" :color="snackbarType" multi-line="false" timeout="3000" vertical="true">
      {{ message }}
      <v-btn dark flat @click="snackbar = false">
        {{ $t("close") }}
      </v-btn>
    </v-snackbar>

    <v-dialog persistent dark v-model="cartDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("cart") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" fab outline small @click="cartDialog = false;"><v-icon dark>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-list-tile v-for="(item, key) in cartItems" :key="key" avatar>
            <v-list-tile-avatar>
              <img :src="'/service/img/public/works/' + item.works_img">
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.works_details_title }}</v-list-tile-title>
              <v-list-tile-sub-title>¥{{ item.works_price }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon ripple　@click="deleteItemFromCart(item.works_id)">
                <v-icon color="grey lighten-1">close</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile>
            <v-list-tile-avatar>{{ $t("amount") }}</v-list-tile-avatar>
            <v-list-tile-content>¥{{ cartTotalAmount }}</v-list-tile-content>
            <v-list-tile-action></v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-btn v-if="cartTotalAmount !== 0" color="dark darken-1" outline round block @click="checkOut()">{{ $t("proceed-to-checkout") }}</v-btn>
          </v-list-tile>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="registerDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("register") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" fab outline small @click="registerDialog = false;$refs.registerForm.reset()"><v-icon dark>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-form ref="registerForm" v-model="registerValid" lazy-validation>
                  <v-text-field v-model="registerEmail" :rules="emailRules" :label="$t('email') + '*'" outline required></v-text-field>
                  <v-text-field v-model="registerPassword" :rules="passwordRules" :label="$t('password') + '*'" outline type="password" required></v-text-field>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark darken-1" outline round :disabled="!registerValid" @click="register">{{ $t("register") }}</v-btn>
                  </v-card-actions>
                </v-form>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="title text-xs-center mb-3">{{ $t("or-register-with") }}</div>
                <v-btn color="dark darken-1" outline round block @click="loginwith('facebook')"><v-icon>mdi-facebook-box</v-icon> facebook</v-btn>
                <v-btn color="dark darken-1" outline round block @click="loginwith('twitter')"><v-icon>mdi-twitter</v-icon> twitter</v-btn>
                <v-btn color="dark darken-1" outline round block @click="loginwith('google')"><v-icon>mdi-google</v-icon> Google</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="loginDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("login") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" fab outline small @click="loginDialog = false;$refs.loginForm.reset();authSuccess = true"><v-icon dark>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-form ref="loginForm">
                  <v-text-field v-model="loginEmail" :rules="authRules" :label="$t('email') + '*'" outline></v-text-field>
                  <v-text-field v-model="loginPassword" :rules="authRules" :label="$t('password') + '*'" outline type="password"></v-text-field>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="dark darken-1" outline round @click="login">{{ $t("login") }}</v-btn>
                  </v-card-actions>
                </v-form>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="title text-xs-center mb-3">{{ $t("or-login-with") }}</div>
                <v-btn color="dark darken-1" outline round block @click="loginwith('facebook')"><v-icon>mdi-facebook-box</v-icon> facebook</v-btn>
                <v-btn color="dark darken-1" outline round block @click="loginwith('twitter')"><v-icon>mdi-twitter</v-icon> twitter</v-btn>
                <v-btn color="dark darken-1" outline round block @click="loginwith('google')"><v-icon>mdi-google</v-icon> Google</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-toolbar dark flat clipped-right app>
      <router-link to="/"><v-img :src="require('./assets/logo.png')" height="50" width="207"></v-img></router-link>
      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down">
        <v-btn to="/creators">{{ $t("creators") }}</v-btn>
        <v-btn @click="registerDialog = true" v-if="!isAuth">{{ $t("register") }}</v-btn>
        <v-btn @click="loginDialog = true" v-if="!isAuth">{{ $t("login") }}</v-btn>
        <v-btn to="/mypage" v-if="isAuth">{{ $t("mypage") }}</v-btn>
        <v-btn @click="logout()" v-if="isAuth">{{ $t("logout") }}</v-btn>
        <v-menu open-on-hover offset-y>
        <v-btn slot="activator" dark>
          {{ currentLocaleLabel }}<v-icon dark>arrow_drop_down</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(locale, key) in locales" :key="key" @click="changeLocale(key)">
            <v-list-tile-title class="active">{{ locale.label }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
        </v-menu>
        <!-- v-btn>{{ $t("order-name") }}</v-btn>
        <v-btn>{{ $t("sell-works") }}</v-btn -->
        <v-btn @click="cartDialog = true;">
          <v-badge overlap color="#e53341">
            <span slot="badge">{{ cartTotal }}</span>
            <v-icon large color="grey lighten-1">shopping_cart</v-icon>
          </v-badge>
        </v-btn>
      </div>
      <v-btn small @click="cartDialog = true;" class="hidden-md-and-up">
        <v-badge overlap color="#e53341">
          <span slot="badge">{{ cartTotal }}</span>
          <v-icon color="grey lighten-1">shopping_cart</v-icon>
        </v-badge>
      </v-btn>
      <v-toolbar-side-icon  @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
    </v-toolbar>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      dark
      id = "drawer"
    >
    <v-list class="pa-1">
      <v-menu open-on-hover offset-y>
      <v-btn slot="activator" dark>
        {{ currentLocaleLabel }}<v-icon dark>arrow_drop_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile v-for="(locale, key) in locales" :key="key" @click="changeLocale(key)">
          <v-list-tile-title class="active">{{ locale.label }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
      </v-menu>
      <v-list-tile to="/creators">
        <v-list-tile-action>
          <v-icon>people</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t("creators") }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="registerDialog = true" v-if="!isAuth">
        <v-list-tile-action>
          <v-icon>assignment_turned_in</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t("register") }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="loginDialog = true" v-if="!isAuth">
        <v-list-tile-action>
          <v-icon>mdi-login</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t("login") }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile to="/mypage" v-if="isAuth">
        <v-list-tile-action>
          <v-icon>assignment_ind</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t("mypage") }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="logout()" v-if="isAuth">
        <v-list-tile-action>
          <v-icon>mdi-logout</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ $t("logout") }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    </v-navigation-drawer>
    <v-content>
      <transition name="fade" mode="out-in">
        <router-view :cart-items="cartItems" :cart-total-amount="cartTotalAmount" @getItemsFromCart="getItemsFromCart" @showNotification="showNotification" @getAuth="getAuth"></router-view>
      </transition>
    </v-content>
    <v-footer height="100%">
      <v-layout justify-center row wrap>
        <v-flex xs12 class="creator-register">
          <v-layout justify-center row wrap>
            <v-flex xs12 sm5 md4 lg2 pa-5 align-self-center class="creator-register-logo">
              <v-responsive><v-img :src="require('./assets/creator-register.png')"></v-img></v-responsive>
            </v-flex>
            <v-flex xs12 sm5 md4 lg2 py-3 align-self-center class="creator-register-text">{{ $t("calligrapher-and-partner") }}</v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 class="footer-menu">
          <v-layout justify-center row wrap>
            <v-flex xs12 sm6 md3 py-4 px-5>
              <h4>{{ $t("about-samuraistock") }}</h4>
              <ul>
                <li>SAMURAISTOCKについて</li>
                <li>よく寄せられるご質問</li>
              </ul>
              <h4 class="mt-5">特徴</h4>
              <ul>
                <li>注目のカリグラフィー</li>
                <li>ブログ</li>
                <li>チュートリアル</li>
              </ul>
              <h4 class="mt-5">サービス</h4>
              <ul>
                <li>コーポレートプラス</li>
                <li>SAMURAISTOCKパートナープログラム</li>
                <li>SAMURAISTOCK APIプログラム</li>
              </ul>
            </v-flex>
            <v-flex xs12 sm6 md3 py-4 px-5>
              <h4>書を買いたい</h4>
              <ul>
                <li>定額料金パッケージ</li>
                <li>チケットの購入</li>
                <li>ライトボックス</li>
                <li>ダウンロード履歴</li>
                <li>よく寄せられるご質問</li>
              </ul>
              <h4 class="mt-5">カリグラファーの方</h4>
              <ul>
                <li>書を売る</li>
                <li>プロフィール＆作品集</li>
                <li>書のアップロード</li>
                <li>アップロード履歴</li>
                <li>報酬</li>
                <li>紹介</li>
                <li>Tax Center</li>
              </ul>
            </v-flex>
            <v-flex xs12 sm6 md3 py-4 px-5>
              <h4>{{ $t("international") }}</h4>
              <ul>
                <li v-for="(locale, key) in locales" :key="key">
                  <a href="#" @click="changeLocale(key)">{{ locale.label }}</a>
                </li>
              </ul>
            </v-flex>
            <v-flex xs12 sm6 md3 py-4 px-5>
              <h4>ポリシー</h4>
              <ul>
                <li>ライセンス規約</li>
                <li>ライセンス概要表</li>
                <li>プライバシー・ポリシー</li>
                <li>ご利用規約</li>
              </ul>
              <h4 class="mt-5">サポート</h4>
              <ul>
                <li>お問い合わせ</li>
                <li>ライブチャット</li>
                <li>Skype</li>
              </ul>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>
<style>
.creator-register {
   background-color: #E53341;
}
.creator-register-logo {
  text-align: center;
}
.creator-register-text {
  text-align: left;
  color: #FFFFFF;
  font-size: 24px;
  white-space: pre-wrap;
  font-family: myriad-pro, sans-serif;
}
.footer-menu {
  background-color: #EAE5CC;
}
.footer-menu li {
  font-size: 12px;
}
@media only screen and (min-width: 1904px) {
  .container {
      max-width: 900px;
  }
}
@media only screen and (min-width: 1264px) {
  .container {
      max-width: 900px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@media only screen and (max-width: 959px) {
  .v-badge--overlap .v-badge__badge {
    top: -10px;
    right: -14px;
  }
}
@media only screen and (max-width: 599px) {
  .creator-register-text {
    text-align: center;
  }
}
</style>
<script>
export default {
  name: "App",
  data () {
    return {
      locales: {
        en: {label: "ENGLISH"},
        ja: {label: "日本語"}
      },
      cartItems: [],
      cartTotal: "",
      cartTotalAmount: "",
      cartDialog: false,
      isAuth: this.$store.state.auth,
      group: this.$store.state.group,
      currentLocaleLabel: "",
      drawer: false,
      snackbar: false,
      snackbarType: "",
      message: "",
      registerDialog: false,
      registerValid: true,
      registerEmail: "",
      registerPassword: "",
      loginDialog: false,
      loginEmail: "",
      loginPassword: "",
      authSuccess: true,
      emailRules: [
        v => !!v || this.$t("email-is-required"),
        v => /.+@.+/.test(v) || this.$t("email-must-be-valid"),
      ],
      passwordRules: [
        v => !!v || this.$t("password-is-required"),
        v => (v && v.length >= 8) || this.$t("password-is-atleast-8"),
      ],
      authRules: [
        v => this.authSuccess || this.$t("it-may-be-incorrect")
      ]
    }
  },
  created() {
    this.currentLocaleLabel = this.locales[this.$store.state.locale].label
    this.getItemsFromCart()
    this.$axios
      .get("/service/api/public/locale")
      .then(response => {
        const locale = response.data.locale;
        this.$i18n.locale = locale;
        this.$store.commit("setLocale", locale);
        this.currentLocaleLabel = this.locales[locale].label
      })
  },
  methods: {
    register() {
      if (this.$refs.registerForm.validate()) {
        const params = new URLSearchParams();
        params.append("email", this.registerEmail);
        params.append("password", this.registerPassword);
        params.append("ss_csrf_token", this.getToken());
        this.$axios
          .post("/service/api/public/register", params)
          .then(response => {
            this.$refs.registerForm.reset();
            this.registerDialog = false;
            this.showNotification('success', response.data.message);
            this.getAuth();
          }).catch(error => {
            this.showNotification('error', error.response.data.error.message);
          });
      }
    },
    login() {
      const params = new URLSearchParams();
      params.append("email", this.loginEmail);
      params.append("password", this.loginPassword);
      params.append("ss_csrf_token", this.getToken());
      this.$axios
        .post("/service/api/public/login", params)
        .then(response => {
          this.$refs.loginForm.reset();
          this.loginDialog = false;
          this.showNotification('success', response.data.message);
          this.getAuth();
          this.authSuccess = true;
          this.getItemsFromCart();
        }).catch(error => {
          this.showNotification('error', error.response.data.error.message);
          this.authSuccess = false;
          this.$refs.loginForm.validate();
        });
    },
    getAuth() {
      this.$axios
        .get("/service/api/public/auth")
        .then(response => {
          const auth = response.data.auth;
          const group = response.data.group;
          const notification = response.data.notification;
          const provider = this.$store.state.provider;
          this.$store.commit("setAuth", auth);
          this.$store.commit("setGroup", group);
          this.isAuth = auth;
          this.group = group;
          if (provider !== null) {
            if(auth) {
              this.showNotification('success', this.$t("login-with-" + provider));
            }
            this.$store.commit("setProvider", null);
          }
          if(notification !== null) {console.log(notification);
            this.showNotification(notification['type'], notification['message']);
          }
        })
    },
    getItemsFromCart() {
      this.$axios
        .get("/service/api/public/itemsfromcart")
        .then(response => {
          this.cartItems = response.data.items;
          this.cartTotal = this.cartItems.length;
          this.cartTotalAmount = response.data.total_amount;
        })
    },
    deleteItemFromCart(works_id) {
      const params = new URLSearchParams();
      params.append("works_id", works_id);
      params.append("ss_csrf_token", this.getToken());
      this.$axios
        .delete("/service/api/public/itemfromcart", {data: params})
        .then(response => {
          this.getItemsFromCart();
        }).catch(error => {
          this.showNotification('error', error.response.data.error.message);
        });
    },
    checkOut() {
      if(!this.isAuth) {
        this.showNotification('warning', this.$t("login-to-checkout"));
        this.cartDialog = false;
        this.loginDialog = true;
      } else {
        this.cartDialog = false;
        this.$router.push({ path: '/checkout' });
      }
    },
    showNotification(type, message) {
      this.snackbarType = type;
      this.message = message;
      this.snackbar = true;
    },
    loginwith(provider) {
      const params = new URLSearchParams();
      params.append("backurl", location.href);
      params.append("ss_csrf_token", this.getToken());
      this.$axios
        .post("/service/api/public/backurl", params)
        .then(response => {
          if(!this.isAuth) {
            this.$store.commit("setProvider", provider);
            location.href = "/service/auth/provider/" + provider;
          }
        }).catch(error => {
          this.showNotification('error', error.response.data.error.message);
        });
    },
    logout() {
        const params = new URLSearchParams();
        params.append("ss_csrf_token", this.getToken());
        this.$axios
          .delete("/service/api/public/logout", {data: params})
          .then(response => {
            this.$store.commit("setAuth", false);
            this.$store.commit("setGroup", "");
            this.isAuth = false;
            this.showNotification('success', this.$t("loggedout"));
            this.$router.push({ path: '/' });
            this.getItemsFromCart();
          }).catch(error => {
            this.showNotification('error', error.response.data.error.message);
          });
    },
    changeLocale(key) {
      const params = new URLSearchParams();
      params.append("locale", key);
      params.append("ss_csrf_token", this.getToken());
      this.$axios
        .put("/service/api/public/locale", params)
        .then(response => {
          this.currentLocaleLabel = this.locales[key].label;
          this.$i18n.locale = key;
          this.$store.commit("setLocale", key);
          this.getItemsFromCart()
        }).catch(error => {
          this.showNotification('error', error.response.data.error.message);
        });
    }
  }
}
</script>
